
<div class="art-image-container">

  <app-art-image-fade-animated [inputData]="data" class="art-image">
  </app-art-image-fade-animated>
  <!--  maximum 7 tags-->
</div>
<div class="layout">
  <div class="description">
    <h1>Kunsten at drømme</h1>
    <p>Hvad ser du for dig, når du tænker på det meningsfulde <br/> arbejds- og pensionsliv?</p>
    <button (click)="takeSurvey()" mat-flat-button class="button">
      <mat-icon>arrow_forward</mat-icon>
      Skab dit AI-kunstværk
    </button>

  </div>
  <div class="shape">
    <svg viewBox="0 0 252 469" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M252 -23.7249L252 342.84C252 412.427 195.588 468.839 126 468.839C56.4121 468.839 3.50192e-06 412.427 2.94319e-06 342.839L0 -23.7248L252 -23.7249Z"
        fill="#B94B50"/>
    </svg>
  </div>
</div>
